import { SIGNO_MONEDA } from "../config/Config";

const FormatMoney = (num) => {
    return '' +SIGNO_MONEDA+ num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export default FormatMoney;